

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const CustomerResponsibilitiesSection = () => {
  return (
    <div>
      <Paragraph>
        Customer is responsible for using TrackBiz in a lawful, accurate, and
        appropriate manner for Customer's internal business operations.
      </Paragraph>

      <Paragraph>
        <Text strong>Customer is responsible for maintaining accurate business information, including:</Text>
      </Paragraph>

      <ul>
        <li>Inventory information</li>
        <li>Product and service pricing</li>
        <li>Customer records</li>
        <li>Order information</li>
        <li>Appointment records</li>
        <li>Employee and user access credentials</li>
        <li>Business contact and website information</li>
      </ul>

      <Alert
        message="Accuracy of Business Data"
        description="Provider is not responsible for losses, incorrect sales, inventory mistakes, appointment issues, or reporting errors resulting from incorrect, incomplete, or outdated information entered by Customer or Customer's employees."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer is responsible for managing employee access to TrackBiz, including
        creating, updating, disabling, or removing user access when employees,
        contractors, or other authorized users no longer require access.
      </Paragraph>

      <Paragraph>
        Customer is responsible for maintaining the confidentiality of account
        usernames, passwords, verification codes, and other login credentials.
      </Paragraph>

      <Paragraph>
        Customer is responsible for all activity that occurs under Customer's
        account, including activity performed by employees, contractors, agents,
        or other authorized users.
      </Paragraph>

      <Alert
        message="Compliance Responsibility"
        description="Customer is responsible for complying with all laws, regulations, tax obligations, licensing requirements, consumer protection rules, and business recordkeeping obligations applicable to Customer's business."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer agrees not to use TrackBiz for unlawful, fraudulent, abusive, or
        unauthorized purposes, and agrees not to interfere with the security,
        availability, or normal operation of the TrackBiz platform.
      </Paragraph>
    </div>
  );
};

export default CustomerResponsibilitiesSection;